import React, { ReactElement, useEffect } from 'react';
import { Spinner } from 'elmo-elements';
import { useGetUserInfoQuery } from '@/modules/services';

export const Logout = (): ReactElement => {
  const userInfo = useGetUserInfoQuery();

  useEffect(() => {
    if (userInfo.isSuccess && userInfo.data) {
      window.location.href = `https://${userInfo.data.oauthHost}/logout`;
    }
  }, [userInfo]);

  return (
    <div className="error-spinner">
      <Spinner />
    </div>
  );
};

export default Logout;
